import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'rgba(26,54,93,0.95)',
        color: 'rgba(255,255,255,0.88)',
        py: { xs: 1.25, md: 1.5 },
        mt: 'auto',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', mb: 1 }} />
        <Typography 
          variant="caption" 
          align="center"
          sx={{ 
            display: 'block',
            width: '100%',
            opacity: 0.72,
            fontSize: { xs: '0.72rem', md: '0.76rem' },
            lineHeight: 1.35,
            '& span': {
              color: 'rgba(255,255,255,0.92)',
              fontWeight: 500,
            }
          }}
        >
          Desenvolvido por <span>Renato Luiz de Almeida</span> e <span>Carlos Guilherme Ferreira</span> - 
          Todos os direitos reservados © 2026
        </Typography>
        <Typography 
          variant="caption" 
          align="center"
          sx={{ 
            display: 'block', 
            width: '100%',
            mt: 0.5,
            opacity: 0.52,
            fontSize: { xs: '0.66rem', md: '0.7rem' },
            lineHeight: 1.3,
            whiteSpace: { xs: 'normal', md: 'nowrap' },
          }}
        >
          Sistema de Consulta de Valores Devidos (Ação do 1/3 de Férias) - Versão 1.0.0
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;